import { createAction } from 'redux-actions';
import initialState from './initialState';
import formatActionTypeNames from '../helpers/formatActionTypeNames';

import { actions as authActions } from './auth.reducer';

export const actions = formatActionTypeNames(
	{
		setState: 'SET_STATE',
		pages: 'PAGES',
		setPage: 'SET_PAGE',
	},
	'POS',
);

export const posActions = {
	setState: createAction(actions.setState),
	pages: createAction(actions.pages),
	setPage: createAction(actions.setPage),
};

export default (state = initialState.pos, action) => {
	const { payload } = action;

	switch (action.type) {
		case actions.setState:
			return {
				...state,
				...payload,
			};

		case actions.setPage:
			return {
				...state,
				pages: {
					...state.pages,
					...payload,
				},
			};

		case authActions.logoutComplete:
			return initialState.pos;

		default:
			return state;
	}
};
